import {
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  getDocs,
  query,
  where,
  orderBy,
  serverTimestamp
} from 'firebase/firestore';
import { db } from './config';

// ==================== DAILY SCHEDULE ITEMS ====================

export const createScheduleItem = async (userId, itemData) => {
  try {
    const scheduleRef = collection(db, 'dailySchedule');
    const docRef = await addDoc(scheduleRef, {
      ...itemData,
      userId,
      createdAt: serverTimestamp()
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error creating schedule item:', error);
    return { success: false, error };
  }
};

export const getScheduleItems = async (userId) => {
  try {
    const scheduleRef = collection(db, 'dailySchedule');
    const q = query(
      scheduleRef,
      where('userId', '==', userId),
      orderBy('startTime', 'asc')
    );
    const querySnapshot = await getDocs(q);
    const items = [];
    querySnapshot.forEach((doc) => {
      items.push({ id: doc.id, ...doc.data() });
    });
    return { success: true, items };
  } catch (error) {
    console.error('Error getting schedule items:', error);
    return { success: false, error };
  }
};

export const updateScheduleItem = async (itemId, itemData) => {
  try {
    const itemRef = doc(db, 'dailySchedule', itemId);
    await updateDoc(itemRef, {
      ...itemData,
      updatedAt: serverTimestamp()
    });
    return { success: true };
  } catch (error) {
    console.error('Error updating schedule item:', error);
    return { success: false, error };
  }
};

export const deleteScheduleItem = async (itemId) => {
  try {
    const itemRef = doc(db, 'dailySchedule', itemId);
    await deleteDoc(itemRef);
    return { success: true };
  } catch (error) {
    console.error('Error deleting schedule item:', error);
    return { success: false, error };
  }
};

// Helper to convert time string (HH:MM) to minutes since midnight
export const timeToMinutes = (timeStr) => {
  const [hours, minutes] = timeStr.split(':').map(Number);
  return hours * 60 + minutes;
};

// Helper to convert minutes to time string
export const minutesToTime = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
};
